<template>
  <div class="sweepCodeBinding">
    <img
      src="../../assets/images/updataFile/testBoxIcon.png"
      class="icon"
    >
    <div class="title">条码号贴在样本采集试管上扫码绑定信息</div>
    <div class="describe">条码号一经绑定，不可更改和再次绑定</div>
    <div
      class="sweepCodeBtnBox"
      @click="scanQRCode"
    >
      <img src="../../assets/images/updataFile/sweepCodeIcon.png">
      <div class="txt">扫一扫</div>
      <div class="txt">条码号</div>
    </div>
    <div
      @click="goManualBinding(subOrderNo)"
      class="goManualBinding"
    >手动绑定<img src="../../assets/images/updataFile/arrow-right-icon.png"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      subOrderNo: "",
      type: "",
    };
  },
  created() {
    this.subOrderNo = this.$route.query.subOrderNo;
    this.type = this.$route.query.type;
    if (this.type == 2 && !localStorage.getItem("systemUserInfo")) {
      localStorage.setItem("redirect", location.hash.slice(1));
      this.$router.replace({
        name: "nurseLogin",
      });
    } else if (!this.type) {
      if (!localStorage.getItem("userInfo")) {
        this.$goLogin();
      }
    }
    if (!this.$store.state.wxConfigFlag) this.$wxConfig();
  },
  methods: {
    goManualBinding(subOrderNo) {
      if (this.type) {
        this.$router.push({
          name: "manualBinding",
          query: {
            subOrderNo: subOrderNo,
            type: this.type,
          },
        });
      } else {
        this.$router.push({
          name: "manualBinding",
          query: {
            subOrderNo: subOrderNo,
          },
        });
      }
    },
    /**
     * 在微信浏览器中打开微信扫码
     */
    scanQRCode(subOrderNo) {
      if (this.$isWeixin()) {
        this.wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["barCode"], // 可以指定扫二维码还是一维码，默认二者都有
          success: (res) => {
            let arr = res.resultStr.split(",");
            let barCode = "";
            if (arr.length == 1) {
              barCode = arr[0];
            } else {
              barCode = arr[1];
            }
            if (localStorage.getItem("multipleChoiceArr"))
              this.bindMultipleChoice(barCode);
            else this.$bindBox(this.subOrderNo, barCode, this.type);
          },
        });
      } else {
        this.$toots("请在微信内置浏览器打开扫码");
      }
    },
    // 一个条码号绑定多个项目
    bindMultipleChoice(barCode) {
      if (this.$store.state.closureFlag) {
        // this.$store.state.closureFlag = false;

        this.$http.get(`/detectBox/getByBarCode/${barCode}`).then((res) => {
          if (res.data.code == 200) {
            let barCodeInfo = res.data.data;

            if (barCodeInfo.subOrderNo) {
              this.$toots("当前条码号已绑定");
              return;
            }
            let list = JSON.parse(localStorage.getItem("multipleChoiceArr"));
            let newList = [];
            for (let i = 0; i < list.length; i++) {
              if (i == 0) {
                newList.push({
                  barCode: barCode,
                  subOrderNo: list[i],
                  id: barCodeInfo.id,
                });
              } else
                newList.push({
                  barCode: barCode,
                  subOrderNo: list[i],
                });
            }
            this.$loading("提交中");
            this.$http
              .post(`/detectBox/batchBindBox`, newList, {
                qs: "no",
              })
              .then((res) => {
                if (res.data.code == 200) {
                  localStorage.removeItem("multipleChoiceArr");
                  this.$tootsSuccess("保存成功");
                  setTimeout(() => {
                    this.$router.replace({
                      name: "MyTesting",
                    });
                  }, 1500);
                } else this.$toots(res.data.msg);
              })
              .catch((err) => {
                this.$toots("系统正在升级，请稍后");
              });
          }
        });
      }
    },
  },
};
</script>

<style lang='less' scoped>
.sweepCodeBinding {
  text-align: center;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding-top: 142px;
  .icon {
    width: 750px;
    height: 426px;
    margin: 0 auto;
  }
  .title {
    font-size: 36px;
    line-height: 54px;
    margin: 0 auto;
    margin-top: 20px;
    width: 478px;
    font-weight: 700;
  }
  .describe {
    margin-top: 20px;
    font-size: 26px;
    color: #999999;
  }
  .sweepCodeBtnBox {
    width: 250px;
    height: 250px;
    margin: 0 auto;
    margin-top: 100px;
    border-radius: 250px;
    background: #1968a8;
    color: #fff;
    font-size: 30px;
    img {
      width: 63px;
      height: 65px;
      margin-top: 50px;
    }
  }
  .goManualBinding {
    margin-top: 40px;
    font-size: 26px;
    color: #999;
    padding-bottom: 50px;
    margin-left: 20px;
    img {
      width: 14px;
      height: 24px;
      margin-left: 10px;
      vertical-align: middle;
      padding-bottom: 6px;
    }
  }
}
</style>
